<script>
import ButtonNormal from '@/components/buttons/ButtonNormal.vue';
export default {
    name: 'WizardAdminFirstStep',
    components: {
        ButtonNormal,
    },
    props: {
        title: String,
        description: String,
        image: String
    },
    methods: {
        getImage(name) {
            const images = require.context('../../../assets/wizard', false, /\.svg$/);
            return images('./' + name + '.svg');
        }
    }
};
</script>

<template>
  <div class="wizard-content-step">
    <div class="wizard-content-header">
        <div class="description">
            <h1>{{title}}</h1>
            <p v-html="description"></p>
        </div> 
    </div>  
    <div class="blocks">
        <div class="block">
            <div class="image" >
               <img :src="getImage(image)" atl="Wizard image"/>
            </div>
        </div>
    </div>
    <div class="blocks one-column">
        <div class="actions center">
            <ButtonNormal @onClick="() => this.$emit('on_next','')" buttonTitle="Rufnummer auswählen" cssClass="btn btn-primary"/>
        </div>
    </div>
</div>
</template>

<style lang="scss" scoped>
@import './step.scss';
</style>
